import React from 'react'
import styled from 'styled-components';


const Root = styled.div``;
const Container = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
padding: 11.0938px 16px 11.0938px 23.2969px;
gap: 21.08px;

`;
const Select = styled.select`
background: rgba(162, 163, 164, 0.18);
border-radius: 8px;
color: white;
padding: 10px 25px;
border: none;
outline: none;
`;
const Option = styled.option`
background-color:black;
color:white;
padding: 10px 0;
border-radius:5px;
font-weight:bolder;
padding: 10px 0;
border-radius:10px;
cursor:pointer;

`;


const DropdownComponent = () => {
  return (
    <Root>
      <Container>
        <Select name="Nft" id="Nft" >
          <Option value="Popular"> Popular </Option>
          <Option value="Rare"> Rare </Option>
          <Option value="Legendary"> Legendary </Option>
        </Select>

      </Container>
    </Root>
   
  );
};

export default DropdownComponent